import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { getProcessedTextPreview } from "../../../utilities/NewsUtilities";
import { formatDisplayDate } from "../../../utilities/CommonUtilities";

const NewsDetailDiv = ({ news, onClose, isDark }) => {
  const theme = useMemo(
    () =>
      isDark
        ? {
            bg: "#0F1424",
            border: "#232B4A",
            text: "#E8ECF8",
            muted: "#A6B0CF",
            link: "#8AB4FF",
            detailBg: "rgba(255,255,255,0.03)",
          }
        : {
            bg: "#FFFFFF",
            border: "#E9ECEF",
            text: "#0B1220",
            muted: "#6C757D",
            link: "#0D6EFD",
            detailBg: "#FAFAFA",
          },
    [isDark],
  );

  const displayDate = formatDisplayDate(new Date(news.data_timestamp));
  const title = news.document_name
    ? news.document_name
    : getProcessedTextPreview(news.processed_text, 100);

  const sourceUrl = news.public_data_source_url;

  const relevanceIndicator = (() => {
    const score = news.ner_relevance_score;
    if (score > 0.5) {
      return {
        color: "green",
        icon: <i className="fa-solid fa-caret-up" />,
        title: "High Relevance",
      };
    } else if (score > 0) {
      return {
        color: "#ffc107",
        icon: <i className="fa-solid fa-xs fa-circle" />,
        title: "Moderate Relevance",
      };
    } else {
      return {
        color: "red",
        icon: <i className="fa-solid fa-caret-down" />,
        title: "Low Relevance",
      };
    }
  })();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <div
      className="d-flex flex-column h-100"
      style={{ background: theme.bg, color: theme.text }}
    >
      <div className="w-100 text-start">
        <div
          className="d-flex justify-content-between align-items-start gap-3 mb-3 pb-3"
          style={{ borderBottom: `1px solid ${theme.border}` }}
        >
          <div className="fw-bold h4 mb-0" style={{ color: theme.text }}>
            {title}
          </div>
          <Button
            variant={isDark ? "outline-light" : "secondary"}
            onClick={handleClose}
            style={{
              border: isDark ? `1px solid ${theme.border}` : undefined,
              flexShrink: 0,
            }}
          >
            Close
          </Button>
        </div>

        <div
          className="d-flex justify-content-start align-items-center gap-2 mb-3 flex-wrap"
          style={{ color: theme.muted }}
        >
          <div>
            <a
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: theme.link, textDecoration: "none" }}
            >
              <i className="fa-solid fa-globe" /> Source
            </a>
          </div>

          <span style={{ color: theme.muted }}>|</span>

          <div>
            <i className="fa-regular fa-calendar me-2" />
            {displayDate}
          </div>

          {news.ner_relevance_score !== null &&
            news.ner_relevance_score !== undefined && (
              <>
                <span style={{ color: theme.muted }}>|</span>
                <div>
                  Relevance:
                  <span
                    style={{
                      color: relevanceIndicator.color,
                      fontSize: "15px",
                    }}
                    title={relevanceIndicator.title}
                    className="ms-2"
                  >
                    {relevanceIndicator.icon} {news.ner_relevance_score}
                  </span>
                </div>
              </>
            )}
        </div>

        {news.summary && (
          <div
            className="mb-3"
            style={{
              color: theme.muted,
              background: theme.detailBg,
              border: `1px solid ${theme.border}`,
              borderRadius: 12,
              padding: 14,
            }}
          >
            <div
              className="mb-2"
              style={{ color: theme.text, fontWeight: 600 }}
            >
              Summary
            </div>
            <div>{news.summary}</div>
          </div>
        )}
      </div>

      {!news.summary && (
        <div
          style={{
            color: theme.muted,
            background: theme.detailBg,
            border: `1px solid ${theme.border}`,
            borderRadius: 12,
            padding: 14,
          }}
        >
          No summary available for this item.
        </div>
      )}

    </div>
  );
};

export default NewsDetailDiv;
